<template>
	<div class="mt-5">
		<v-lazy
			v-for="(group, i) in data"
			:key="`group-${group.id}-${i}`"
			v-model="isActive[i]"
			:options="{ threshold: 0 }"
			:transition="null"
			min-height="100"
		>
			<div
				v-if="
					i == data.length - 2 &&
					typeof isActive[i] !== 'undefined'
				"
				v-intersect="infiniteScrolling"
			/>
			<v-divider v-if="i > 0" class="my-4" :key="'group-list-divider-' + i" />
			<groups-list-item
				:item="group"
				:key="'group-list-item-' + i"
			/>
		</v-lazy>
	</div>
</template>

<script>
import GroupsListItem from "@/components/groups/GroupsListItem";
export default {
	name: "GroupsList",
	components: {
		GroupsListItem,
	},
	props: {
		data: {
			type: Array,
			required: true
		},
		infiniteScrolling: {
			type: Function,
			required: false
		},
	},
	data () {
		return {
			isActive: [true],
		}
	},
}
</script>

<style scoped>

</style>
